// extracted by mini-css-extract-plugin
export default {"small":"Small_small__ac1J3"};